export default function HowWeSolveIt() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4">
            How Fast Passport Center Handles Urgent Passports
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left — text */}
          <div className="flex-1 space-y-5">
            <p className="text-gray-700 leading-relaxed">
              Fast Passport Center is registered under the U.S. Department of State's Hand Carry Program. Our couriers physically hand-deliver passport applications to federal agencies every single business day — using reserved submission slots that are not available to the public.
            </p>
            <p className="text-gray-700 leading-relaxed">
              This is the key difference. When you come to us with an urgent passport need, your application doesn't go into a mail queue. It doesn't pass through a middleman. Our courier walks it directly into the agency the next business day and it gets processed within the reserved timeframe — 3, 4, 7, or 9 business days depending on which tier you choose.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We've been doing this for over 20 years. Urgent passports are not an exception for us — they're our everyday business.
            </p>
          </div>

          {/* Right — visual card */}
          <div className="flex-1 bg-amber-50 rounded-lg border border-amber-200 p-6 md:p-8">
            <h3 className="text-lg font-bold text-amber-900 mb-5">The Fast Passport Center Difference:</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>Hand-courier delivery to agency — no mail queues</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>Reserved daily agency submission slots</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>Expert document review before submission</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>24 nationwide drop-off locations</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>Overnight FedEx return delivery</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>Real-time tracking dashboard</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>U.S.-based support — real humans</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>A+ BBB, 20+ years registered courier</span>
              </li>
              <li className="flex items-start gap-3 text-gray-700 text-sm">
                <i className="ri-checkbox-circle-fill text-amber-600 text-lg flex-shrink-0 mt-0.5"></i>
                <span>20–80% less than FedEx or Staples</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}